module.exports = __webpack_public_path__ + "img/pencil-filter-right_jp.1cad32b.jpg";